import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { NavigateState } from '../types/teikihoan/commonDefinition';

export const usePageNavigate = () => {
  const navigate = useNavigate();

  const pageNavigate = useCallback(
    (path: string, state: NavigateState) => {
      navigate(path, { state });
    },
    [navigate]
  );

  const menuPage = useCallback(
    (state: NavigateState) => {
      navigate('/menu', { state });
    },
    [navigate]
  );

  const teikihoanPage = useCallback(
    (state: NavigateState) => {
      navigate('/teikihoan', { state });
    },
    [navigate]
  );

  const kaisenPage = useCallback(
    (state: NavigateState) => {
      navigate('/kaisen', { state });
    },
    [navigate]
  );

  const heisenPage = useCallback(
    (state: NavigateState) => {
      navigate('/heisen', { state });
    },
    [navigate]
  );

  const inputMailPage = useCallback(
    (state: NavigateState) => {
      navigate('/mail', { state });
    },
    [navigate]
  );

  const resevationPage = useCallback(
    (state: NavigateState) => {
      navigate('/resevation', { state });
    },
    [navigate]
  );

  return {
    pageNavigate,
    menuPage,
    teikihoanPage,
    inputMailPage,
    resevationPage,
    kaisenPage,
    heisenPage,
  };
};
